import { render, staticRenderFns } from "./ContestPlayerInfo.vue?vue&type=template&id=7bb22941&"
import script from "./ContestPlayerInfo.vue?vue&type=script&lang=js&"
export * from "./ContestPlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports